module.exports = __webpack_public_path__ + "static/img/bi-business-intelligence-ts-100646689-orig-4.be9b9226.webp";